import LocalStorage from '@/services/LocalStorage';
import EnvelopesService from '@/modules/business/services/http/envelopes/EnvelopesService';

const STORAGE_KEY = 'envelope_configs';
const CACHE_TTL = 86400000; // 24 hours in milliseconds

const KB_TO_MB = (kb) => Math.floor(Number(kb) / 1024);

export default {
  namespaced: true,
  state: {
    singleDocumentSizeLimitMB: null,
    documentsPerEnvelopeLimit: null,
    recipientsPerEnvelopeLimit: null,
    documentsPerEnvelopeSizeLimitMB: null,
    loading: false,
    error: false,
  },
  getters: {
    singleDocumentSizeLimitMB: (state) => state.singleDocumentSizeLimitMB,
    documentsPerEnvelopeLimit: (state) => state.documentsPerEnvelopeLimit,
    recipientsPerEnvelopeLimit: (state) => state.recipientsPerEnvelopeLimit,
    documentsPerEnvelopeSizeLimitMB: (state) =>
      state.documentsPerEnvelopeSizeLimitMB,
    loading: (state) => state.loading,
    error: (state) => state.error,
  },
  mutations: {
    setConfig(
      state,
      { singleSizeMB, docsPerEnv, recipientsPerEnv, docsSizePerEnvMB }
    ) {
      state.singleDocumentSizeLimitMB = singleSizeMB;
      state.documentsPerEnvelopeLimit = docsPerEnv;
      state.recipientsPerEnvelopeLimit = recipientsPerEnv;
      state.documentsPerEnvelopeSizeLimitMB = docsSizePerEnvMB;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
    setError(state, error) {
      state.error = error;
    },
  },
  actions: {
    async fetchConfigs({ commit }) {
      commit('setLoading', true);

      try {
        const cached = LocalStorage.get(STORAGE_KEY);
        if (
          cached &&
          cached.single_document_size_limit !== undefined &&
          Date.now() - cached.cached_at < CACHE_TTL
        ) {
          commit('setConfig', {
            singleSizeMB: KB_TO_MB(cached.single_document_size_limit),
            docsPerEnv: Number(cached.documents_per_envelope_limit),
            recipientsPerEnv: Number(cached.recipients_per_envelope_limit),
            docsSizePerEnvMB: KB_TO_MB(
              cached.documents_per_envelope_size_limit
            ),
          });
          commit('setLoading', false);
          return;
        }
      } catch {
        // ignore cache errors
      }

      try {
        const res = await EnvelopesService.getConfigs();
        const data = res.data;
        const cacheData = {
          single_document_size_limit: data.single_document_size_limit,
          documents_per_envelope_limit: data.documents_per_envelope_limit,
          recipients_per_envelope_limit: data.recipients_per_envelope_limit,
          documents_per_envelope_size_limit:
            data.documents_per_envelope_size_limit,
          cached_at: Date.now(),
        };
        LocalStorage.set(STORAGE_KEY, cacheData);
        commit('setConfig', {
          singleSizeMB: KB_TO_MB(data.single_document_size_limit),
          docsPerEnv: Number(data.documents_per_envelope_limit),
          recipientsPerEnv: Number(data.recipients_per_envelope_limit),
          docsSizePerEnvMB: KB_TO_MB(data.documents_per_envelope_size_limit),
        });
        commit('setError', false);
      } catch {
        commit('setConfig', {
          singleSizeMB: 25,
          docsPerEnv: 25,
          recipientsPerEnv: 20,
          docsSizePerEnvMB: 100,
        });
        commit('setError', true);
      } finally {
        commit('setLoading', false);
      }
    },
  },
};
